import { AuthContext } from '@/auth/context';
import { Button } from '@/components/ui/button';
import { useContext } from 'react';
import googleIcon from '@/assets/icons/google-icon.svg';

export function GoogleLoginButton({ onClick }: { onClick?: () => void }) {
  const { login } = useContext(AuthContext);

  return (
    <Button
      type="button"
      onClick={onClick ?? (() => login())}
      variant={'ghost'}
      className="w-full border-2 rounded-lg px-6 py-4 sm:px-8 sm:py-6 border-slate-400 bg-[#f7f7f9] hover:bg-[#E8ECF2] font-semibold text-base sm:text-lg md:text-xl lg:text-2xl leading-tight"
    >
      <img src={googleIcon} alt="" aria-hidden="true" className="inline-block mr-3 w-5 h-5 sm:w-6 sm:h-6" />
      Continue with Google
    </Button>
  );
}
